module.exports = "/assets/7818f630f5fb2bf7f1698cc3638d9504.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/LG.png
// module id = 1578
// module chunks = 0